import {css} from '@emotion/react'

import {
    AiProvider,
    ButtonMain,
    ButtonPromptHistory,
    Chat,
} from '@/biz/ai'

import {
    ButtonClearContext,
    SelectSession,
} from '@/biz/ai/agent'

import ButtonChooseTemplate from './ButtonChooseTemplate.jsx'
import useAi from './useAi.jsx'

const cssAiAgent = css({
    display: 'grid',
    gridTemplateRows: '1fr',
    position: 'relative',
    height: '100%',
    overflow: 'hidden',
})

export default function AiAgent({agentCode, map, ...props}) {
    const ai = useAi({agentCode, map})

    const tools = [
        <>
            <ButtonChooseTemplate promptTemplateCode={agentCode} />
        </>,

        <>
            <SelectSession />
            <ButtonClearContext />
            <ButtonPromptHistory />
            <ButtonMain />
        </>
    ]

    return (
        <AiProvider value={ai}>
            <Chat
                css={cssAiAgent}
                tools={tools}
                {...props}
            />
        </AiProvider>
    )
}
